var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#EFF4F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9997 23.9582H22.5664C24.383 23.9582 25.708 21.9416 25.708 20.2416C25.6968 19.6869 25.5719 19.1404 25.3412 18.6359C25.1104 18.1313 24.7786 17.6795 24.3664 17.3082C23.7168 16.7485 22.8715 16.4697 22.0164 16.5332C21.9419 16.5413 21.8665 16.5345 21.7947 16.5133C21.7229 16.492 21.6559 16.4567 21.5978 16.4095C21.5397 16.3622 21.4915 16.3039 21.4561 16.2378C21.4206 16.1718 21.3987 16.0995 21.3914 16.0249C21.0497 10.5916 12.9164 10.6666 12.7914 16.2499C12.7894 16.3639 12.7545 16.4748 12.6909 16.5694C12.6273 16.664 12.5378 16.7383 12.433 16.7832C11.6628 17.1647 11.042 17.7925 10.6691 18.5669C10.2962 19.3414 10.1926 20.2182 10.3747 21.0582C10.4789 21.5815 10.6923 22.0768 11.0011 22.5119C11.3098 22.947 11.7069 23.3121 12.1664 23.5832C12.7423 23.8957 13.3965 24.0346 14.0497 23.9832H15.0914",
    stroke: "#0DA14B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 23.9918V18.2168",
    stroke: "#0DA14B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1914 19.883L17.9997 18.083L19.8081 19.883",
    stroke: "#0DA14B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.54903c4b40b8aaf2a2ca0a45a49eee4f.svg";
export { ForwardRef as ReactComponent };